export enum Distractibility { 
    QuiteSensitiveDistractible = 1,
    LowSensitiveOverFocussed = 3
    }